import React, { useState } from 'react';
import { Info, X } from 'lucide-react';
import { Button } from '../UI/button';
import { useLocale } from '../../contexts/LocaleContext';
import { colors } from '../../config/colors';
import { cn } from '../../lib/utils';

const DISMISS_KEY = 'tenantOnboardingBannerDismissed';

function TenantCompanyOnboardingBanner({ visible, onGoToOverview, onGoToImport }) {
  const { t } = useLocale();
  const [dismissed, setDismissed] = useState(() => {
    try {
      return localStorage.getItem(DISMISS_KEY) === '1';
    } catch {
      return false;
    }
  });

  if (!visible || dismissed) {
    return null;
  }

  const handleDismiss = () => {
    setDismissed(true);
    try {
      localStorage.setItem(DISMISS_KEY, '1');
    } catch {
      /* ignore */
    }
  };

  return (
    <div
      className={cn(
        'relative flex flex-col gap-3 rounded-lg border px-4 py-3 sm:flex-row sm:items-center sm:justify-between'
      )}
      style={{
        backgroundColor: colors.warning[50],
        borderColor: colors.warning[200],
      }}
      role="status"
    >
      <span className="flex min-w-0 gap-3">
        <Info
          className="mt-0.5 h-5 w-5 shrink-0"
          style={{ color: colors.warning[600] }}
          aria-hidden
        />
        <span className="min-w-0 block">
          <p className="text-sm font-semibold" style={{ color: colors.warning[800] }}>
            {t('tenantOnboardingBannerTitle')}
          </p>
          <p className="mt-1 text-sm" style={{ color: colors.warning[700] }}>
            {t('tenantOnboardingBannerDescription')}
          </p>
        </span>
      </span>
      <span className="flex shrink-0 flex-wrap items-center gap-2">
        <Button type="button" size="sm" variant="outline" onClick={onGoToOverview}>
          {t('tenantOnboardingBannerCtaOverview')}
        </Button>
        <Button type="button" size="sm" onClick={onGoToImport}>
          {t('tenantOnboardingBannerCtaImport')}
        </Button>
        <Button
          type="button"
          size="icon-sm"
          variant="ghost"
          onClick={handleDismiss}
          aria-label={t('tenantOnboardingDismiss')}
        >
          <X className="h-4 w-4" />
        </Button>
      </span>
    </div>
  );
}

export default TenantCompanyOnboardingBanner;